import _ from 'lodash';
import { roundQuantity, transformUom } from './amount';

// function decorateIngredientData(ingredientEntry = {}, language) {
//   const quantity = roundQuantity(ingredientEntry.amount.metric.quantityOut);
//   const uom = transformUom(ingredientEntry.amount.metric.uomCode);
//   const amount = {};
//   amount.amountInfo = {};
//   amount.amountInfo[language] = {};
//   amount.amountInfo[language].metric = `${roundQuantity(
//     ingredientEntry.amount.metric.quantityOut
//   )} ${transformUom(ingredientEntry.amount.metric.info[language].textShort)}`;
//   amount.amountInfo[language].imperial = `${roundQuantity(
//     ingredientEntry.amount.imperial.quantityOut
//   )} ${transformUom(ingredientEntry.amount.imperial.info[language].textShort)}`;
//   // const amount = `${quantity} ${uom}`;
//   return {
//     ...ingredientEntry,
//     amount
//   };
// }
function decorateIngredientData(ingredientEntry = {}, language, franchiseType) {
  const isNir = franchiseType === "NIR";
  const metricQuantity = isNir
    ? ingredientEntry?.amount?.metric?.displayQuantityOut
    : ingredientEntry?.amount?.metric?.quantityOut;

  const metricInfo = isNir
    ? ingredientEntry?.amount?.metric?.displayInfo?.[language]
    : ingredientEntry?.amount?.metric?.info?.[language];

  const imperialQuantity = isNir
    ? ingredientEntry?.amount?.imperial?.displayQuantityOut
    : ingredientEntry?.amount?.imperial?.quantityOut;

  const imperialInfo = isNir
    ? ingredientEntry?.amount?.imperial?.displayInfo?.[language]
    : ingredientEntry?.amount?.imperial?.info?.[language];

  const amount = {
    amountInfo: {
      [language]: {}
    }
  };

  amount.amountInfo[language].metric = `${roundQuantity(
    metricQuantity
  )} ${transformUom(metricInfo?.textShort)}`;

  amount.amountInfo[language].imperial = `${roundQuantity(
    imperialQuantity
  )} ${transformUom(imperialInfo?.textShort)}`;

  return {
    ...ingredientEntry,
    amount
  };
}


class Ui2pStitchPPSI {
  constructor(ppsiData = {}, ppis = [], ingredientEntries = [], language, franchiseType) {
    this.ppsiData = ppsiData;
    this.ppis = ppis;
    this.ingredientEntries = ingredientEntries;
    this.language = language;
    this.franchiseType=franchiseType
  }

  getIngredientData(id) {
    // return this.ingredientEntries.find(entry => entry.id === id);
    return decorateIngredientData(
      this.ingredientEntries.find(entry => entry.id === id),
      this.language,
      this.franchiseType
    );
  }

  getIngredientDataByItemCode(itemCode) {
    const ingredientEntry = this.ingredientEntries.find(
      entry => entry.itemCode === itemCode
    );
    // return ingredientEntry;
    // console.log("1",this.ingredientEntries,itemCode)
    return decorateIngredientData(ingredientEntry, this.language, this.franchiseType);
  }

  getPpiByItemCode(itemCode) {
    return this.ppis.find(ppi => ppi.itemCode === itemCode);
  }

  getPpiById(id) {
    return this.ppis.find(ppi => ppi.id === id);
  }

  isIngredientInPpiDetails(ingredient = {}, ppiDetails) {
    const { itemCode } = ingredient;
    return _.find(ppiDetails, { itemCode });
  }

  stitchPpsi() {
    return _.omit(this.ppsiData, ['dish', 'utensils']);
  }

  stitchPpiDetails() {
    const ppiDetails = [];

    // a) Add from PPI Details on PPSI
    _.get(this.ppsiData, 'ppiDetails', []).forEach(ppiDetail => {
      // console.log("ppiDetails",this.ppsiData)
      const { itemCode } = ppiDetail;
      const ingredient = this.getIngredientDataByItemCode(itemCode);
      const ppi = this.getPpiByItemCode(itemCode);

      ppiDetails.push({
        itemCode,
        ingredient,
        ppi
      });
    });

    // b) Add missing PPI Details from ingredient entries on PPSI
    _.get(this.ppsiData, 'ingredientEntryIds', []).forEach(
      ingredientEntryId => {
        // console.log("ingredientEntryId",ingredientEntryId)
        const ingredient = this.getIngredientData(ingredientEntryId);
        if (this.isIngredientInPpiDetails(ingredient, ppiDetails)) {
          return;
        }
        const { itemCode } = ingredient;
        const ppiDetail = {
          itemCode,
          ingredient,
          ppi: null
        };
        ppiDetails.push(ppiDetail);
      }
    );

    return ppiDetails;
  }

  stitchServingInstructions() {
    return _.get(this.ppsiData, 'servingInstructions', []).map(
      servingInstruction => {
        const result = _.omit(servingInstruction, 'ppiEnrichmentId');
        const { ppiEnrichmentId } = servingInstruction;
        const ppi = this.getPpiById(ppiEnrichmentId);
        return {
          ...result,
          ppi
        };
      }
    );
  }

  stitch() {
    const { formulaCode } = this.ppsiData.dish;
    const ppsi = this.stitchPpsi();
    const ppiDetails = this.stitchPpiDetails();
    const servingInstructions = this.stitchServingInstructions();

    return {
      ...ppsi,
      ppiDetails,
      servingInstructions,
      formulaCode
    };
  }
}

export default function(ppsiData, ppis, ingredientEntries, language = null,franchiseType=null) {
  return new Ui2pStitchPPSI(
    ppsiData,
    ppis,
    ingredientEntries,
    language,
    franchiseType
  ).stitch();
}
